import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { UserCircleLight } from '@quizzach/assets';
import { RoutePath } from '@quizzach/interfaces';
import { BtnTeal } from '@quizzach/styles';
import { ModalShell } from '@quizzach/components';

export const AuthenticationModal = ({
	path,
	closeModal,
}: {
	path: string;
	closeModal: () => void;
}) => {
	const { t } = useTranslation();

	return (
		<ModalShell
			onClose={closeModal}
			size='sm'
			center
			icon={<UserCircleLight size={52} />}
			title={t('modal.auth.loginRequiredTitle')}
			actions={
				<BtnTeal
					$small
					as={Link}
					to={RoutePath.Login}
					state={{ redirect: path, google_referer: path }}
				>
					{t('modal.auth.loginRegister')}
				</BtnTeal>
			}
		>
			<p style={{ margin: 0 }}>{t('modal.auth.loginRequiredText')}</p>
		</ModalShell>
	);
};

export const AuthQuizCreation = ({
	path,
	source,
	closeModal,
}: {
	path: string;
	source: string;
	closeModal: () => void;
}) => {
	const { t } = useTranslation();

	return (
		<ModalShell
			onClose={closeModal}
			size='sm'
			center
			icon={<UserCircleLight size={52} />}
			title={t('modal.auth.personalizationTitle')}
			actions={
				<BtnTeal
					$small
					as={Link}
					to={RoutePath.Login}
					state={{ source: source, google_referer: path }}
				>
					{t('modal.auth.loginRegister')}
				</BtnTeal>
			}
		>
			{source === 'quick-init' && (
				<p style={{ margin: 0 }}>{t('modal.auth.quickInitText')}</p>
			)}
		</ModalShell>
	);
};
